/* eslint-disable react-hooks/exhaustive-deps */
// wijmo

import React, { useContext, useEffect, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import TextInput from "../../../components/InputWrapper/TextInput"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { ModalOuter, TModalTypes } from "../../../components/Modal/ModalOuter"
import Spinner from "../../../components/Spinner"
import dayjs from "dayjs"
import ComboBox from "../../../components/ComboBox"
import { showInfoToast } from "../../../components/CustomToast"
// import { useSelector } from "react-redux"
// import { RootState } from "../../../globalStore/rootreducer"
import DateInput from "../../../components/InputWrapper/DateInput"

import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"

import { setAlerts } from "../../../globalStore/alertStore"
import SyaryoSyozokuService from "../../../service/truck/syaryoSyozoku/syaryoSyozokuService"
import { useDispatch } from "react-redux"
import { AppDispatch } from "../../.."
import ZyomuinSearchModal from "../../../components/SearchModal/ZyomuinSearchModal"
import { TApiResponse } from "../../../service/TApiResponse"

import BusyoService from "../../../service/master/busyo/busyoService"
import TextAreaInput from "../../../components/InputWrapper/TextAreaInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import { FunctionContext } from "../../../components/Context"

/**
 * 異動登録モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const IdoRegisterModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    車輌ID: number
    登録更新: "登録" | "更新"
  }
> = (props) => {
  //#region [state]
  // 検索用
  const pageSearch = useContext(FunctionContext)

  //アラート制御
  const disPatch: AppDispatch = useDispatch()

  // 固定
  const [車番, set車番] = useState<string>()
  const [所属開始日, set所属開始日] = useState<string>()
  const [現在の部所, set現在の部所] = useState<string>()
  const [現在の担当, set現在の担当] = useState<string>()
  const [車種, set車種] = useState<string>()
  const [登録番号, set登録番号] = useState<string>()
  const [使用者名称, set使用者名称] = useState<string>()
  const [車輌営業所, set車輌営業所] = useState<string>()
  // state
  const [異動日, set異動日] = useState<string>("")
  const [乗務員コード, set乗務員コード] = useState<string>("")
  const [乗務員名, set乗務員名] = useState<string>("")
  const [表示順, set表示順] = useState<number>(0)
  const [備考, set備考] = useState<string>("")

  const [削除フラグ, set削除フラグ] = useState<0 | 1>(0)
  const [更新日時, set更新日時] = useState<string>("")

  // ComboBoxState
  // 部所ComboBox
  const [部所コード, set部所コード] = useState<string>("")
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [部所isLoadEnded, set部所isLoadEnded] = useState<boolean>(false)

  // 異動日はシステム日付より先のみ設定可
  // const yokueigyobi = useSelector(
  //   (state: RootState) => state.date.yokueigyobiStr
  // )

  // init
  const [initialDataSetFlag, setInitialDataSetFlag] = useState(false)

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  // 乗務員検索
  const [is乗務員検索Modal, setIs乗務員検索Modal] = useState(false)

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)
  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()

  //#endregion

  //#region [method]
  /**
   * データ取得
   */
  const getData = async (id: number, signal: AbortSignal) => {
    const service = new SyaryoSyozokuService()

    try {
      const res = await service.getSyaryoSyozoku(id)
      if (res.data) {
        // 現在情報
        set車番(res.data.現在_車番)
        set所属開始日(res.data.現在_所属開始日)
        set現在の部所(res.data.現在_部所名)
        set現在の担当(res.data.現在_社員名)
        set車種(res.data.車種区分名称1)
        set登録番号(res.data.登録番号)
        set使用者名称(res.data.使用者情報_会社名)
        set車輌営業所(res.data.車輌営業所区分名称1)

        // 異動先情報
        set乗務員コード(res.data.異動先_社員コード)
        set乗務員名(res.data.異動先_社員名)
        set異動日(res.data.異動先_所属開始日)
        set部所コード(res.data.異動先_部所コード)
        set表示順(res.data.異動先_表示順)
        set備考(res.data.異動先_備考)
        set削除フラグ(res.data.異動先_削除フラグ)
        set更新日時(res.data.異動先_更新日時)
      }
    } catch (error) {
      setAlertSource(error)
    }
  }

  const beforeSubmit = () => {
    // TODO:バリデーションチェック

    setIsConfirmModalShow(true)
  }

  //TODO:PUTのみAPIで処理
  const submit = async () => {
    try {
      let data = {
        異動先_所属開始日: 異動日,
        異動先_部所: 部所コード,
        異動先_乗務員: 乗務員コード,
        異動先_表示順: 表示順,
        異動先_備考: 備考,
        更新日時,
        削除フラグ,
      }

      const service = new SyaryoSyozokuService()

      let res: TApiResponse<boolean>

      // 登録/更新ともに親マスタのPKが必要になるため
      // 呼び出し元の車輌IDを引数に与える。
      if (props.登録更新 === "更新") {
        res = await service.putSyaryoSyozokuTo(props.車輌ID.toString(), data)
      } else {
        res = await service.postSyaryoSyozokuTo(props.車輌ID.toString(), data)
      }

      disPatch(setAlerts(res))
      if (res) {
        props.setIsShow(false)
        showInfoToast(
          `異動先の車輌所属マスタの${
            props.車輌ID ? "更新" : "登録"
          }が完了しました。`
        )
        pageSearch()
      }
    } catch (error) {
      // disPatch(setAlerts(error))
      setAlertSource(error)
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  //#endregion

  //#region [effect]

  useEffect(() => {
    setAlertSource(undefined)

    if (部所ComboBox == null) return

    if (props.isShow) {
      Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
        set部所ItemSource(部所ListRes.data)

        setInitialDataSetFlag(true)
      })
      // setIsSpinnerShow(false)
    } else {
      // 非表示時中身を空にして閉じる
      set車番("")
      set所属開始日("")
      set現在の部所("")
      set現在の担当("")
      set登録番号("")
      set使用者名称("")
      set車輌営業所("")
      set車種("")
      set異動日("")
      set乗務員コード("")
      set乗務員名("")
      set表示順(0)
      set備考("")
      set削除フラグ(0)
      set更新日時("")

      setIsSpinnerShow(true)
    }
  }, [props.isShow, 部所ComboBox])

  useEffect(() => {
    if (initialDataSetFlag) {
      const abortController = new AbortController()
      getData(props.車輌ID, abortController.signal).finally(() => {
        setInitialDataSetFlag(false)
        setIsSpinnerShow(false)
      })
    } else {
      setIsSpinnerShow(false)
    }
  }, [initialDataSetFlag])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "異動登録"}
      setIsShow={props.setIsShow}
      size={"lg"}
      footer={
        <>
          {props.登録更新 === "更新" && (
            <Button
              type="submit"
              variant="caution"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                // 削除する為、削除フラグを制御
                set削除フラグ(1)
                beforeSubmit()
              }}>
              削除
            </Button>
          )}
          <Button
            type="submit"
            variant="waiting"
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              // 更新する為、削除フラグを制御
              set削除フラグ(0)
              beforeSubmit()
            }}>
            更新
          </Button>
        </>
      }>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid className="register-form">
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <ul className="list-cmn">
                <li className="list-cmn  d-flex">
                  <div className="d-flex">
                    <TextInput
                      style={{ width: "5rem" }}
                      id="車番"
                      name="車番"
                      value={車番}
                      isReadOnly={true}
                      setValue={() => {}}
                      placeholder="車番"
                    />
                    <TextInput
                      style={{ width: "5rem" }}
                      id="車輌id"
                      name="車輌id"
                      value={props.車輌ID ? props.車輌ID.toString() : ""}
                      isReadOnly={true}
                      setValue={() => {}}
                      placeholder="車輌ID"
                    />
                    <TextInput
                      style={{ width: "20rem" }}
                      id="車種"
                      name="車種"
                      value={車種}
                      isReadOnly={true}
                      setValue={() => {}}
                      placeholder="車種"
                    />
                  </div>
                </li>

                <li className="list-cmn d-flex">
                  <div className="d-flex">
                    <TextInput
                      id="登録番号"
                      name="登録番号"
                      value={登録番号}
                      isReadOnly={true}
                      setValue={() => {}}
                      placeholder="登録番号"
                    />
                    <TextInput
                      id="使用者名称"
                      name="使用者名称"
                      value={使用者名称}
                      isReadOnly={true}
                      setValue={() => {}}
                      placeholder="使用者名称"
                    />
                    <TextInput
                      id="車輌営業所"
                      name="車輌営業所"
                      value={車輌営業所}
                      isReadOnly={true}
                      setValue={() => {}}
                      placeholder="車輌営業所"
                    />
                  </div>
                </li>

                <li className="list-cmn d-flex">
                  <div className="d-flex w-8rem">
                    <TextInput
                      id="所属開始日"
                      name="所属開始日"
                      value={dayjs(所属開始日!).format("YYYY/MM/DD")}
                      isReadOnly={true}
                      setValue={() => {}}
                      placeholder="所属開始日"
                    />
                  </div>
                  <div>
                    <TextInput
                      style={{ width: "20rem" }}
                      id="現在の部所"
                      name="現在の部所"
                      value={現在の部所}
                      isReadOnly={true}
                      setValue={() => {}}
                      placeholder="現在の部所"
                    />
                  </div>
                  <div className="d-flex">
                    <TextInput
                      style={{ width: "12rem" }}
                      id="readonly担当乗務員"
                      name="readonly担当乗務員"
                      value={現在の担当}
                      isReadOnly={true}
                      setValue={() => {}}
                      placeholder="担当乗務員"
                    />
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
          {/* 異動日 */}
          <MasterRegisterFormRow label="異動日" isRequired={true}>
            <div className="w-10rem">
              <DateInput
                id="異動日"
                // min={yokueigyobi}
                isRequired
                value={異動日}
                setValue={(v) => {
                  set異動日(v!)
                }}></DateInput>
            </div>
          </MasterRegisterFormRow>
          {/* 異動先部所 */}
          <MasterRegisterFormRow label="異動先部所" isRequired={true}>
            <ComboBox.Busyo
              autoFocus={true}
              isEmpty={true}
              isRequired={true}
              itemsSource={部所ItemSource}
              isLoadEnded={部所isLoadEnded}
              setIsLoadEnded={set部所isLoadEnded}
              selectedValue={部所コード}
              setSelectedValue={(v) => {
                set部所コード(v!)
              }}
              ComboBox={部所ComboBox}
              setComboBox={set部所ComboBox}></ComboBox.Busyo>
          </MasterRegisterFormRow>
          {/* 担当乗務員 */}
          <MasterRegisterFormRow label="異動先担当乗務員">
            <TextInput
              style={{ width: "12rem" }}
              id="担当乗務員"
              name="担当乗務員"
              value={乗務員名}
              isReadOnly={true}
              setValue={() => {}}
            />
            <button
              type="button"
              className="icon-button"
              onClick={(e) => {
                e.preventDefault()
                setIs乗務員検索Modal(true)
              }}>
              <FontAwesomeIcon
                className="icon-button-inner"
                icon={faSearch}></FontAwesomeIcon>
            </button>
            <Button
              className="btn btn-small btn-primary move-edit-page"
              onClick={() => {
                // 乗務員情報をclearする。
                set乗務員コード("")
                set乗務員名("")
              }}>
              クリア
            </Button>
          </MasterRegisterFormRow>
          {/* 表示順 */}
          {/* <MasterRegisterFormRow label="表示順" isRequired={true}>
            <NumberInput
              style={{ width: "5rem" }}
              id="表示順"
              name="表示順"
              min={0}
              step={1}
              value={表示順}
              setValue={set表示順}></NumberInput>
          </MasterRegisterFormRow> */}
          {/* 備考 */}
          <MasterRegisterFormRow label="備考" isRequired={false}>
            <TextAreaInput
              style={{ width: "30rem" }}
              id="備考"
              name="備考"
              value={備考}
              setValue={set備考}></TextAreaInput>
          </MasterRegisterFormRow>
        </form>
      </Container>
      {/* 乗務員検索 */}
      <ZyomuinSearchModal
        isShow={is乗務員検索Modal}
        setIsShow={setIs乗務員検索Modal}
        setZyomuin={(乗務員) => {
          set乗務員コード(乗務員.社員コード)
          set乗務員名(乗務員.社員氏名)
        }}></ZyomuinSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容{削除フラグ ? "を削除" : "で更新"}しますか？
      </ConfirmModal>
    </ModalOuter>
  )
}

export default IdoRegisterModal
